import React from 'react';

const FoundationRegistration = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Foundation Registration</h1>
        
        <div className="prose prose-lg max-w-none">
          <div className="bg-blue-50 border-l-4 border-blue-400 p-6 mb-8">
            <h2 className="text-2xl font-semibold text-blue-900 mb-4">Kibouor Foundation (SG)</h2>
            <p className="text-blue-800 mb-2">Registered Charity under the Charities Act (Cap. 37), Singapore</p>
            <p className="text-blue-800 mb-2"><strong>UEN:</strong> 202514625N</p>
          </div>
          
          <h3 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Registered Address:</h3>
          <p className="text-gray-700 mb-6">
            80 Robinson Road, #14-01, Singapore 068898
          </p>
          
          <h3 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Entity Type:</h3>
          <p className="text-gray-700 mb-6">
            Company Limited by Guarantee (Non-Profit)
          </p>
          
          <h3 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Governed by:</h3>
          <p className="text-gray-700 mb-6">
            Singapore Charities Commission
          </p>
          
          <h3 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Verification:</h3>
          <p className="text-gray-700 mb-6">
            Charities Portal – Singapore
          </p>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-200">
          <a href="/" className="text-blue-600 hover:underline">← Back to Home</a>
        </div>
      </div>
    </div>
  );
};

export default FoundationRegistration;
